import { Modal } from 'antd';

interface DeletePlanConfirmModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

export function DeletePlanConfirmModal({
  open,
  onConfirm,
  onCancel,
  loading,
}: DeletePlanConfirmModalProps) {
  return (
    <Modal
      title="Confirm Delete"
      open={open}
      onOk={onConfirm}
      onCancel={onCancel}
      confirmLoading={loading}
      okText="Delete"
      okButtonProps={{ danger: true }}
    >
      <p>Are you sure you want to delete this plan? This action cannot be undone.</p>
    </Modal>
  );
}
